@if (showSpinner()) {
  <div class="container" [class.local]="isVisible() !== null" [class.global]="isVisible() === null">
    <img class="pos-mid spinner" src="assets/TAIS-Logo-Pulse.svg" alt="TAIS-Spinner" />
  </div>
}
